import { InputSummaryItem } from '../../../../input-summary';
import InputSummaryUtils from '../../../../../helper/input-summary/input-summary-util';
import { UnitValue } from '../../../../data-structures/unit-value.model';

/**
 * An interface used to define the class structure for the feedstock bmp potential COD model
 */
export interface FeedstockBmpPotentialCodInterface {
  cod: UnitValue;
  biodegradability: UnitValue;
}

/**
 * A class that contains members for the feedstock BMP potential COD model
 */
export class FeedstockBmpPotentialCod {
  cod: UnitValue;
  biodegradability: UnitValue;

  /**
   * constructs the FeedstockBmpPotentialCod class.
   * @param param is used to construct the class. If null or not provided, the class will be set to default values
   */
  constructor(param: FeedstockBmpPotentialCodInterface = {
    cod: new UnitValue(),
    biodegradability: new UnitValue(),
  }) {
    this.cod = new UnitValue(param.cod);
    this.biodegradability = new UnitValue(param.biodegradability);
  }

  /**
   * returns a separate instance of the provided FeedstockBmpPotentialCod obj
   * @param feedstockBmpPotentialCod will be returned as a separate instance
   */
  static deepCopy(feedstockBmpPotentialCod: FeedstockBmpPotentialCod) {
    let copy;
    if (feedstockBmpPotentialCod) {
      copy = new FeedstockBmpPotentialCod(feedstockBmpPotentialCod);
      return copy;
    }
    throw new Error('unable to perform deep copy of FeedstockBmpPotentialCod');
  }

  /**
   * Returns an array of InputSummaryItem containing inputs for each member of the FeedstockBmpPotentialCod class
   */
  getSummaryInputs(path: string[]) {
    let inputs: InputSummaryItem[] = [];
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpPotentialCodPropName.cod, this.cod, [...path, 'cod']);
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpPotentialCodPropName.biodegradability, this.biodegradability, [...path, 'biodegradability']);
    return inputs;
  }
}

/**
 * An enum that contains a proper display name for properties of the FeedstockBmpPotentialCod class.
 *
 * ALL MEMBERS ARE INTENTIONALLY CAMELCASE FOR OBJ REFERENCING
 */
export enum FeedstockBmpPotentialCodPropName {
  cod = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.COD.COD',
  biodegradability = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.BIODEGRADABILITY',
  id_cod = 'chemical oxygen demand (COD)',
  id_biodegradability = 'biodegradability'
}
